import React from 'react';

const MaintenancePopup: React.FC = () => {
  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center backdrop-blur-xl bg-black/60">
      <div className="bg-white/80 rounded-3xl shadow-2xl p-12 max-w-lg w-full border border-white/30 flex flex-col items-center justify-center animate-fadeIn">
        <h1 className="text-3xl font-bold mb-4 text-red-700 text-center">¡Estamos en mantenimiento!</h1>
        <p className="text-gray-800 text-lg text-center mb-6">El sitio se encuentra temporalmente en modo mantenimiento.<br />Por favor, vuelve a intentarlo más tarde.</p>
        <div className="w-20 h-20 border-8 border-red-400 border-t-transparent rounded-full animate-spin mb-2" />
      </div>
    </div>
  );
};

export default MaintenancePopup; 